function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { addTracingExtensions, getMainCarrier } from '@sentry/core';
import { isNodeEnv, loadModule, dynamicRequire } from '@sentry/utils';
/**
 * @private
 */

function _autoloadDatabaseIntegrations() {
  var carrier = getMainCarrier();

  if (!carrier.__SENTRY__) {
    return;
  }

  var packageToIntegrationMapping = {
    mongodb: function mongodb() {
      var integration = dynamicRequire(module, './node/integrations/mongo');
      return new integration.Mongo();
    },
    mongoose: function mongoose() {
      var integration = dynamicRequire(module, './node/integrations/mongo');
      return new integration.Mongo({
        mongoose: true
      });
    },
    mysql: function mysql() {
      var integration = dynamicRequire(module, './node/integrations/mysql');
      return new integration.Mysql();
    },
    pg: function pg() {
      var integration = dynamicRequire(module, './node/integrations/postgres');
      return new integration.Postgres();
    }
  };
  var mappedPackages = Object.keys(packageToIntegrationMapping).filter(function (moduleName) {
    return !!loadModule(moduleName);
  }).map(function (pkg) {
    try {
      return packageToIntegrationMapping[pkg]();
    } catch (e) {
      return undefined;
    }
  }).filter(function (p) {
    return p;
  });

  if (mappedPackages.length > 0) {
    carrier.__SENTRY__.integrations = [].concat(_toConsumableArray(carrier.__SENTRY__.integrations || []), _toConsumableArray(mappedPackages));
  }
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */


function addExtensionMethods() {
  addTracingExtensions(); // Detect and automatically load specified integrations.

  if (isNodeEnv()) {
    _autoloadDatabaseIntegrations();
  }
}

export { addExtensionMethods };